export function initImageLoaders(root = document) {
  root.querySelectorAll('.lbx-image-loader + img').forEach(img => {
    const loader = img.previousElementSibling;

    if (img.complete) {
      loader.remove();
      return;
    }

    const reveal = () => {
      img.classList.remove('opacity-0');
      loader.classList.add('opacity-0');
      setTimeout(() => loader.remove(), 300);
    };

    img.classList.add('opacity-0');
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
  });
}
